module.exports = __webpack_public_path__ + "img/sicilienske_koedboller.414eee2e.jpg";